module.exports = __webpack_public_path__ + "img/location.19f267dc.svg";